import { render, staticRenderFns } from "./ReplyListComponent.vue?vue&type=template&id=19e35cca&scoped=true&"
import script from "./ReplyListComponent.vue?vue&type=script&lang=js&"
export * from "./ReplyListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReplyListComponent.vue?vue&type=style&index=0&id=19e35cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e35cca",
  null
  
)

export default component.exports